import { type ComponentProps, memo } from 'react'

import View from './Heading.view'

export type ControllerProps = ComponentProps<typeof View>

export const Controller = memo(function HeadingController(props: ControllerProps) {
  return <View {...props} />
})

Controller.displayName = 'Heading_Controller'

export default Controller
